import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  navigate(event) {
    // Don't navigate if clicking on checkbox, menu button, or menu dropdown
    if (event.target.closest('.task-checkbox-wrapper') ||
        event.target.closest('.entry-menu-btn') ||
        event.target.closest('.dropdown-menu')) {
      return
    }

    const url = this.hasUrlValue ? this.urlValue : `/tasks/${this.element.dataset.taskId}`
    if (url) {
      window.location.href = url
    }
  }
}
